import { render, staticRenderFns } from "./module_sku_config.vue?vue&type=template&id=4c407ffa&scoped=true"
import script from "./module_sku_config.vue?vue&type=script&lang=js"
export * from "./module_sku_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c407ffa",
  null
  
)

export default component.exports